export function queryKeyCreator(resource: string) {
  return (...deps: unknown[]) => [resource, ...deps];
}

export type QueryCreatorType = ReturnType<typeof queryKeyCreator>;
